import React from 'react'
import { AuditLogRetention, RetentionResource } from '../../../models/RetentionPolicy'
import { getAuditLogKindLabel } from './auditLogKindLabels'

const EMPTY_FIELD_MESSAGE = '-'

export const RetentionPolicyAuditLogResourceBody: React.FC<{ retentionResource: RetentionResource }> = ({ retentionResource }) => {
  const resource = retentionResource as AuditLogRetention
  return (
    <>
      <div>
        <div>Audit log kind</div>
        <div aria-label='Resource type'>{getAuditLogKindLabel(resource.config?.kind, EMPTY_FIELD_MESSAGE)}</div>
      </div>
    </>
  )
}
